import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import AnimateOnScroll from './AnimateOnScroll';
import ProductMockup from './ProductMockup';
import { heroContent } from '../content/landingContent';

export const HeroSection = () => {
  const scrollToDemo = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 bg-stone-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {heroContent.showHeroImage ? (
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <AnimateOnScroll delay={0}>
              <div className="space-y-8">
                <div className="space-y-6">
                  <h1 className="text-3xl lg:text-4xl font-bold text-stone-900 leading-tight tracking-tight">
                    {heroContent.headline}
                  </h1>
                  <p className="text-xl lg:text-2xl text-stone-600 leading-relaxed max-w-xl font-medium">
                    {heroContent.subheadline}
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 pt-2">
                  <Button 
                    size="lg"
                    onClick={scrollToDemo}
                    className="bg-slate-600 hover:bg-slate-700 text-white rounded-lg transition-all duration-300 text-base px-8 py-6 group"
                  >
                    {heroContent.primaryCTA}
                    <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-200" />
                  </Button>
                  <Button 
                    size="lg"
                    variant="outline"
                    onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
                    className="border-2 border-stone-300 text-stone-700 hover:bg-stone-50 transition-all duration-300 text-base px-8 py-6 rounded-lg"
                  >
                    {heroContent.secondaryCTA}
                  </Button>
                </div>
              </div>
            </AnimateOnScroll>
            
            <AnimateOnScroll delay={200}>
              <div className="relative">
                {/* Product Mockup */}
                <ProductMockup />
              </div>
            </AnimateOnScroll>
          </div>
        ) : (
          /* Typographic Hero - Centered */
          <AnimateOnScroll delay={0}>
            <div className="max-w-4xl mx-auto text-center space-y-10">
              <div className="space-y-6">
                <h1 className="text-5xl lg:text-6xl xl:text-7xl font-bold text-stone-900 leading-tight tracking-tight">
                  {heroContent.headline}
                </h1>
                <p className="text-xl lg:text-2xl text-stone-600 leading-relaxed max-w-3xl mx-auto font-medium">
                  {heroContent.subheadline}
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
                <Button 
                  size="lg"
                  onClick={scrollToDemo}
                  className="bg-slate-600 hover:bg-slate-700 text-white rounded-lg transition-all duration-300 text-base px-10 py-7 group"
                >
                  {heroContent.primaryCTA}
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-200" />
                </Button>
                <Button 
                  size="lg"
                  variant="outline"
                  onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
                  className="border-2 border-stone-300 text-stone-700 hover:bg-stone-50 transition-all duration-300 text-base px-10 py-7 rounded-lg"
                >
                  {heroContent.secondaryCTA}
                </Button>
              </div>
            </div>
          </AnimateOnScroll>
        )}
      </div>
    </section>
  );
};

export default HeroSection;